const ModalType = {
  handleCloseButton: {
    CLOSE: 1,
    BACK: 2
  }
};

export default ModalType;
